import React from 'react';
import styles from './loader.module.css';
import classNames from 'classnames';
export function LoaderIcon(_a) {
    var _b = _a.size, size = _b === void 0 ? 120 : _b;
    return (React.createElement("div", { className: classNames(styles.loaderIconOuter, "kplr_loaderIconOuter") },
        React.createElement("div", { className: styles.loaderIconInner, style: { height: size, width: size } },
            React.createElement("div", { className: styles.loaderIconOval }),
            React.createElement("div", { className: styles.loaderIconOval }),
            React.createElement("div", { className: styles.loaderIconOval }))));
}
export default LoaderIcon;
